export default {
  loading: false,
  schema: null,
  data: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/creator/state.js